import { Box, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { routes } from '../../constants';
import Button from '../../components/Button';
import * as T from '../../components/Typography';
import colors from '../../theme/colors';
import logoWhiteBg from '../../components/assets/logo-navy.png';

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Grid
      container
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      textAlign="center"
    >
      <Box mb={5}>
        <img src={logoWhiteBg} alt="Unauthorized Access" width="118" height="48" />
      </Box>
      <Box mb={2}>
        <T.H4 color={colors.neutral.shades.shade700}>
          UNAUTHORISED ACCESS
        </T.H4>
      </Box>
      <Box mb={4}>
        <T.TextSmallRegular color={colors.neutral.shades.shade600}>
          You do not have permission to view this page.
        </T.TextSmallRegular>
      </Box>
      <Button
        variant="blue"
        width="fit-content"
        handleClick={() => navigate(routes.HOME)}
      >
        Back to portal
      </Button>
    </Grid>
  );
};

export default UnauthorizedPage;
